<template>
  <div class="tab-container">
    <div class="recipe-area">
      <div class="panel-wrapper">
        <div class="sales-panel">
          <div class="panel-header">
            <h3>销售项目</h3>
            <div>
              <Button
                @click="$refs.SACSalesDrawer.openDrawer(selectedSale)"
                v-if="selectedSale"
                style="margin-right: 15px"
              >编辑销售项目</Button>
              <Button @click="$refs.SACSalesDrawer.openDrawer()">添加销售项目</Button>
            </div>
          </div>
          <div class="table">
            <div
              v-for="(e, index) in salesList"
              :key="index"
              :class="{ 'sales-card': true, 'selected': selectedSalesId === e._id}"
              v-on:click="selectSales(e)"
            >
              <div>{{e.customer.name}} — {{e.material.name}} — {{e.name}}</div>
              <div>{{e.NoId}}</div>
            </div>
          </div>
        </div>

        <div class="sales-panel">
          <div class="panel-header">
            <h3>配方列表</h3>
            <div>
              <Button
                v-if="selectedRecipeId"
                @click="$refs.SACRecipeDrawer.openDrawer(selectedSalesId,selectedRecipe)"
                style="margin-right: 15px"
              >编辑配方</Button>
              <Button
                v-if="selectedSalesId"
                @click="$refs.SACRecipeDrawer.openDrawer(selectedSalesId)"
              >创建配方</Button>
            </div>
          </div>
          <div class="sales-table" v-if="selectedSalesId">
            <div
              v-for="(e, index) in recipeList"
              :key="index"
              :class="{ 'sales-card': true, 'selected': selectedRecipeId === e._id}"
              v-on:click="selectRecipe(e._id)"
            >
              <div>
                <span class="prod-tag" v-if="selectedSalesprodRecipeId === e._id">生产配方</span>
                {{e.name || '-'}}
              </div>
            </div>
          </div>
        </div>

        <div class="recipe-panel">
          <div class="panel-header">
            <h3>配方详情</h3>
            <!-- <Button @click="$refs.CreateRecipeDrawer.openDrawer(selectedSalesId)">复制配方</Button> -->
          </div>
          <div class="recipe-table" v-if="selectedRecipeId">
            <Table
              :columns="recipeColumns"
              :data="selectedRecipeDetail"
              border
              show-summary
              :summary-method="handleSummary"
            ></Table>
          </div>
        </div>
      </div>
    </div>
    <SACRecipeDrawer
      v-on:updatedGetRecipe="updatedGetRecipe"
      ref="SACRecipeDrawer"
      v-on:editSuccess="loadSacDetail"
    />
    <SACSalesDrawer ref="SACSalesDrawer" v-on:editSuccess="loadSacDetail" />
  </div>
</template>

<script>
import SACRecipeDrawer from "./components/SACRecipeDrawer";
import SACSalesDrawer from "./components/SACSalesDrawer";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: { SACRecipeDrawer, SACSalesDrawer },
  props: ["sac"],
  data() {
    return {
      page: 0,
      searchText: "",
      customerLoading: false,
      customerTableData: [],
      selectedSale: null,
      selectedSalesId: null,
      selectedRecipeId: null,
      selectedSalesprodRecipeId: null,
      selectedRecipeDetail: [],
      selectedRecipe: {},
      recipeList: [],
      recipeColumns: [
        {
          title: "行",
          key: "row",
          width: 80,
          align: "center",
          render: (h, params) =>
            h("span", { style: { color: "darkgray" } }, params.index + 1),
        },
        {
          title: "原材料",
          key: "material.name",
          minWidth: 200,
          render: (h, params) => h("span", params.row.material.name),
        },
        {
          title: "比例(%)",
          key: "ratio",
          align: "right",
          width: 100,
          render: (h, params) => h("span", params.row.ratio * 100 + "%"),
        },
      ],
    };
  },
  computed: {
    ...mapState({
      salesList: (state) => state.sac.sac.sales,
    }),
  },
  methods: {
    async updatedGetRecipe(sales) {
      await this.getSacById(this.sac._id);
      this.selectSales(sales);
    },
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 0) {
          sums[key] = {
            key,
            value: "合计",
          };
          return;
        }
        if (index === 1) {
          sums[key] = {
            key,
            value: "",
          };
          return;
        }
        const values = data.map((item) => Number(item.ratio));
        if (values && !values.every((value) => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: v * 100 + "%",
          };
        }
      });
      return sums;
    },
    ...mapActions({
      getSacById: "sac/getSacByIdAction",
      getSacRecipe: "sac/getSacRecipeAction",
    }),
    async selectRecipe(_id) {
      if (this.selectedRecipeId === _id) return;
      this.selectedRecipeId = _id;
      this.selectedRecipe = this.recipeList.find((x) => x._id === _id);
      this.selectedRecipeDetail = this.selectedRecipe.detail;
    },
    async selectSales(sales) {
      this.selectedSalesId = sales._id;

      this.selectedSale = sales;
      if (sales.prodRecipe) {
        this.selectedSalesprodRecipeId = sales.prodRecipe;
      } else {
        this.selectedSalesprodRecipeId = null;
      }
      this.selectedRecipeId = null;
      this.recipeList = await this.getSacRecipe({
        sales: this.selectedSalesId,
      });
    },
    loadSacDetail() {
      this.getSacById(this.sac._id);
    },
  },
};
</script>

<style scoped lang="stylus">
.tab-container
  display flex
  width 100%
  height 100%

.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.customer-area
  width 350px

.table-wrapper
  width 100%
  height calc(100% - 48px)

.recipe-area
  width 100%

  .panel-wrapper
    height 100%
    display flex

    .sales-panel
      width 400px
      height 100%

    .recipe-panel, .sales-panel
      flex 1
      padding 0 10px

.material-header
  background-color #515a6e
  padding 8px 24px
  color white

.panel-header
  height 64px
  padding 0px 24px
  display flex
  justify-content space-between
  align-items center

.sales-card
  padding 8px 24px
  border-bottom 1px solid #d3d3d3
  cursor pointer
  font-size 14px
  font-weight bold
  display flex
  justify-content space-between

.selected
  color #fff
  background-color #00008b

.prod-tag
  background-color #19be6b
  color white
  border-radius 4px
  padding 4px
  font-size 12px
  margin-right 15px
</style>
